export const UpgradeUrlStringMap = {
  Ad_DestinationUrl: _TL_('Destination URL'),
  Ad_FinalUrl: _TL_('Final URL'),
  BulkEdit_UrlOptions_CustomParameters_AddAnother: _TL_('Add another'),
  BulkEdit_UrlOptions_CustomParameters_InputAriaLabel: _TL_('Custom parameters {{key}} number {{number}}'),
  BulkEdit_UrlOptions_CustomParameters_MatchCase: _TL_('Match case'),
  BulkEdit_UrlOptions_CustomParameters_RemoveLineNumber: _TL_('Remove custom parameters number {{number}}'),
  BulkEdit_UrlOptions_UpgradeWarning: _TL_('You are about to upgrade this entity to use Final URL. '),
  Cancel: _TL_('Cancel'),
  CustomParameters_Placeholder_Key: _TL_('name'),
  CustomParameters_Placeholder_Value: _TL_('value'),
  ErrorNumber_UniqueCustomParameterNames: _TL_('Custom parameter names must be unique.'),
  Error_Campaign_API_FinalUrlRequiredWhenUsingMobileFinalUrl: _TL_('In order to use a mobile URL a final URL must also be used.'),
  Error_Campaign_API_InvalidCharactersInKey: _TL_('The name of a custom parameter can only contain alphanumeric characters (e.g., 0-9 a-z A-Z).'),
  Error_Campaign_API_InvalidCharactersInValue: _TL_('Value contains invalid characters.'),
  Error_Campaign_API_InvalidTag: _TL_('Value contains invalid tag.'),
  Error_Campaign_API_InvalidUrlScheme: _TL_('The URL entered is invalid. A valid URL must start with http:// or https:// or {lpurl} or {unescapedlpurl}.'),
  Error_Campaign_API_KeyNullOrEmpty: _TL_('Custom parameter requires a name.'),
  FinalUrlSuffix_Example: _TL_('Example: param1=values1&param2=value2'),
  FinalUrlSuffix_Label: _TL_('Final URL suffix'),
  FinalUrl_Label: _TL_('Final URL (recommended)'),
  Input_NoChange_PlaceHolder: _TL_('<No change>'),
  LandingPage_Label: _TL_('Landing page'),
  LearnMore: _TL_('Learn more'),
  MobileFinalUrl_Label: _TL_('Mobile URL'),
  Save: _TL_('Save'),
  TrackingTemplate_Example: _TL_('Example: http://www.trackingtool.com/tracking?url={lpurl}&type=1 '),
  TrackingTemplate_Label: _TL_('Tracking template'),
  UpgradedUrl_Placeholder_FinalUrlSuffix: _TL_('Enter a Final URL suffix'),
  UrlOptions_None: _TL_('None'),
};
